export default __webpack_public_path__ + "static/media/cut.e5112d45.svg";